import { Formik, Form, Field, ErrorMessage } from "formik";
import { useSelector, useDispatch } from "react-redux";
import {
  setStep,
  setmultiMemberLLCDataStep4,
} from "../../../states/legalTools/multiMemberLLCSlice";
import * as Yup from "yup";
import multiMemberLLCServices from "../../../services/MultiMemberLLCService";
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
const MultiMemberLLCFormStep4Schema = Yup.object().shape({
  isLLCOperatingAgreementIncludeDefaultDisputeResolution: Yup.string().required(
    "This field is required"
  ),
  confirmTaxStatus: Yup.string().required("This field is required"),
});
const MultiMemberLLCFormStep4 = () => {
  const multiMemberLLCData = useSelector(
    (state) => state.multiMemberLLC.multiMemberLLCData
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <>
      <Formik
        initialValues={{
          isLLCOperatingAgreementIncludeDefaultDisputeResolution:
            multiMemberLLCData.isLLCOperatingAgreementIncludeDefaultDisputeResolution,
          confirmTaxStatus: multiMemberLLCData.confirmTaxStatus,
          otherInformationNotes: multiMemberLLCData.otherInformationNotes,
        }}
        validationSchema={MultiMemberLLCFormStep4Schema}
        onSubmit={(values) => {
          dispatch(setmultiMemberLLCDataStep4(values));
          const data = {
            ...multiMemberLLCData,
            isLLCOperatingAgreementIncludeDefaultDisputeResolution:
              values.isLLCOperatingAgreementIncludeDefaultDisputeResolution,
            confirmTaxStatus: values.confirmTaxStatus,
            otherInformationNotes: values.otherInformationNotes,
            memberOneIsCash: multiMemberLLCData.memberOneContribution[0],
            memberOneIsService: multiMemberLLCData.memberOneContribution[1],
            memberOneIsPreExistingIntellectualProperty:
              multiMemberLLCData.memberOneContribution[2],
            memberOneIsOtherAssets: multiMemberLLCData.memberOneContribution[3],
            memberOneIsOther: multiMemberLLCData.memberOneContribution[4],
            memberTwoIsCash: multiMemberLLCData.memberTwoContribution[0],
            memberTwoIsService: multiMemberLLCData.memberTwoContribution[1],
            memberTwoIsPreExistingIntellectualProperty:
              multiMemberLLCData.memberTwoContribution[2],
            memberTwoIsOtherAssets: multiMemberLLCData.memberTwoContribution[3],
            memberTwoIsOther: multiMemberLLCData.memberTwoContribution[4],
            memberThreeIsCash: multiMemberLLCData.memberThreeContribution[0],
            memberThreeIsService: multiMemberLLCData.memberThreeContribution[1],
            memberThreeIsPreExistingIntellectualProperty:
              multiMemberLLCData.memberThreeContribution[2],
            memberThreeIsOtherAssets:
              multiMemberLLCData.memberThreeContribution[3],
            memberThreeIsOther: multiMemberLLCData.memberThreeContribution[4],
            memberFourIsCash: multiMemberLLCData.memberFourContribution[0],
            memberFourIsService: multiMemberLLCData.memberFourContribution[1],
            memberFourIsPreExistingIntellectualProperty:
              multiMemberLLCData.memberFourContribution[2],
            memberFourIsOtherAssets:
              multiMemberLLCData.memberFourContribution[3],
            memberFourIsOther: multiMemberLLCData.memberFourContribution[4],
            isEstatePlaningTransfers: multiMemberLLCData.permittedTransfers[0],
            isToHeirsOnDeath: multiMemberLLCData.permittedTransfers[1],
            isWithMemberApproval: multiMemberLLCData.permittedTransfers[2],
            isOtherPermittedTransfers: multiMemberLLCData.permittedTransfers[3],
            isFromAMemberWhoHasWithdrawnOrBeenRemoved:
              multiMemberLLCData.toRepurchaseUnits[0],
            isAnyImproperlyTransferredUnits:
              multiMemberLLCData.toRepurchaseUnits[1],
            isThatHaveBeenTransferredFollowingTheDeathOfAMember:
              multiMemberLLCData.toRepurchaseUnits[2],
            isWhenAnyMemberStopsProvidingServicesToTheCompany:
              multiMemberLLCData.toRepurchaseUnits[3],
            isEachMemberExpectedTimeCommitmentFullTime:
              multiMemberLLCData.expectedTimeCommitment[0],
            isEachMemberExpectedTimeCommitmentPartTime:
              multiMemberLLCData.expectedTimeCommitment[1],
            isEachMemberExpectedTimeCommitmentNeededToRunCompany:
              multiMemberLLCData.expectedTimeCommitment[2],
            isEachMemberExpectedTimeCommitmentOther:
              multiMemberLLCData.expectedTimeCommitment[3],
            isEnterIntoAnyTransaction: multiMemberLLCData.coMemberApproval[0],
            isEnterIntoAnyCustomerEngagements:
              multiMemberLLCData.coMemberApproval[1],
            isApproveDistributionOfAnyProfit:
              multiMemberLLCData.coMemberApproval[2],
            isSetTheAmountAndTermsOfAnyMemberSalary:
              multiMemberLLCData.coMemberApproval[3],
            isAppointOrRemoveAnyOfficers:
              multiMemberLLCData.coMemberApproval[4],
            isHireOrTerminateAnyEmployee:
              multiMemberLLCData.coMemberApproval[5],
            isIssueAnyNewUnitOrAdmitAnyNewMember:
              multiMemberLLCData.coMemberApproval[6],
            isApproveTheTransferOfAnyUnits:
              multiMemberLLCData.coMemberApproval[7],
            isChangeTheBankAccount: multiMemberLLCData.coMemberApproval[8],
            isSignNewLease: multiMemberLLCData.coMemberApproval[9],
            isApproveSale: multiMemberLLCData.coMemberApproval[10],
            isFileOrSettleAnyLawsuit: multiMemberLLCData.coMemberApproval[11],
            isDissolveLiquidateOrWindUp:
              multiMemberLLCData.coMemberApproval[12],
            isTakeAnyOtherMaterialActionOutside:
              multiMemberLLCData.coMemberApproval[13],
            isAmendTheOperatingAgreement:
              multiMemberLLCData.coMemberApproval[14],
            isOtherCoMemberApprovalRequiredTo:
              multiMemberLLCData.coMemberApproval[15],
            isSubmitted:true  
          };
          multiMemberLLCServices
            .AddUpdateCustomerServiceMultiMemberLLCQuestion(data)
            .then((response) => {
              notification.success({
                message: "Submitted successfully!",
              });
              setTimeout(() => {
                navigate("/dashboard");
              }, 2000);
            })
            .catch((error)=>{
              notification.error({
                message: "An error occured",
              });
            })
          console.log(data);
        }}
      >
        {(formik) => (
          <Form>
            <div className="content-box mt-5">
              <h3 className="text-dark content-title">Dispute Resolution</h3>
              <p>
                In the event that there are any disputes between the members and
                managers of the LLC, we recommend that the dispute be handled by
                mediation first and then by arbitration, only if mediation does
                not work. This alternative dispute resolution process is in lieu
                of reliance on courts.
              </p>
              <div className="mb-3">
                <label className="form-label">
                  Would you like the LLC operating agreement to include our
                  default dispute resolution provisions?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="isLLCOperatingAgreementIncludeDefaultDisputeResolution"
                    className="form-check-input"
                    value="true"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="isLLCOperatingAgreementIncludeDefaultDisputeResolution"
                    className="form-check-input"
                    value="false"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    No, I prefer to have any disputes resolved by courts.
                  </label>
                </div>
              </div>
              <ErrorMessage
                name="isLLCOperatingAgreementIncludeDefaultDisputeResolution"
                component="div"
                style={{ color: "red" }}
              />
            </div>
            <div className="content-box mt-5">
              <h3 className="text-dark content-title">Tax Status</h3>
              <p>
                <strong>Default Tax Status:</strong> By default, a multi-member
                LLC will be taxed as a “partnership” by the IRS. You should
                consult with your CPA or tax advisor on the tax filing
                requirements as a partnership.
              </p>
              <p>
                <strong>Note:</strong> It is possible to have your LLC taxed as
                a "S-corp." This special S-corp election as an LLC should be
                done with the guidance of a CPA and may be decided at a later
                date, if determined to be beneficial for your particular
                business.
              </p>

              <div className="mb-3">
                <label className="form-label">
                  Confirm tax status.
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="confirmTaxStatus"
                    className="form-check-input"
                    value="true"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    I confirm the default partnership tax status.
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="confirmTaxStatus"
                    className="form-check-input"
                    value="false"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    I have consulted an accountant or CPA and I have decided to
                    be taxed as an S-Corp.
                  </label>
                </div>
                <ErrorMessage
                  name="confirmTaxStatus"
                  component="div"
                  style={{ color: "red" }}
                />
                <span>
                  Note: C-corp status for an LLC is uncommon and not supported
                  by the LLC Builder at this time. Please contact us to discuss.
                </span>
              </div>
              <div className="mb-3">
                <label className="form-label">Other Information or Notes</label>
                <Field
                  type="text"
                  name="otherInformationNotes"
                  className="form-control"
                  disabled={multiMemberLLCData.isSubmitted}
                />
                <span>
                  Is there any information that you feel is important for us to
                  know on the terms between you and your business partner(s) in
                  the LLC?
                </span>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn-submit-secondary me-2 rounded pe-3 d-flex align-items-center"
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(setStep(3));
                }}
              >
                <i className="fa-solid fa-arrow-left mx-2"></i>PREVIOUS
              </button>
              <button
                type="submit"
                className="submit-button ps-3 d-flex align-items-center"
              >
                FINISH<i className="ms-2 fa-solid fa-arrow-right "></i>
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
export default MultiMemberLLCFormStep4;
